import * as ajax from "./index.js";
const prefix = "http://gzh.llts.com.cn/st";

//const prefix = 'http://gzh.v5time.net/st';

// 授权
export function auth(param) {
  return ajax.post(prefix + '/auth', param);
}

// 分享
export function share(param) {
  return ajax.post(prefix + '/book/signature', param);
}


//绝版好书
export function getGoodBookList(param) {
  return ajax.post(prefix + "/catalog/getGoodBookList", param);
}
export function gdbookType(param) {
  return ajax.post(prefix + "/catalog/categoryList", param);
}
export function getGoodBookDetail(param) {
  return ajax.post(prefix + "/catalog/getGoodBookDetail", param);
}
//好视界
export function getVideoList(param) {
  return ajax.post(prefix + "/book/books", param);
}

//新书目和图书数目
export function catalogApi(param){
  return ajax.post(prefix + '/catalog/newCatalog', param);
}
//banner管理
export function bannerApi(param){
  return ajax.post(prefix + '/book/banner', param);
}

//banner管理
export function bookInfoApi(param){
  return ajax.post(prefix + '/catalog/detail', param);
}
//视频播放详情
export function getAudioDetail(param){
  return ajax.post(prefix + '/book/audioDetail', param);
}

//版权合作and荣誉资质
export function getContentInfo(param){
  return ajax.post(prefix + '/book/info', param);
}

//分页
export function setAudioList(param){
  return ajax.post(prefix + '/book/audioList', param);
}
//用户是否关注公众号
export function isSubscribe(param){
  return ajax.post(prefix + '/common/isSubscribe', param);
}
//web听力分类
export function getListenCategoryInfo(param){
  return ajax.post(prefix + '/catalog/getListenCategoryInfo', param);
}
//web意见反馈上传图片
export function onuploadify(param){
  return ajax.upload(prefix + '/catalog/uploadify', param);
}
//web意见反馈
export function oncreate(param){
  return ajax.post(prefix + '/comment/create', param);
}




// WEBPACK FOOTER //
// ./src/api/apis.js